import { isArray } from "lodash";
import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  getStationComposedId,
  IRideDto,
  isEqualNumberArraysAnyOrder,
  RideStationPanelMode,
  rideStationsCollapsedIdsAF,
} from "@ryde/shared";

import {
  RideStationsHeader,
  RideStationsPanelStyled,
  RideStationWrapper,
} from "./parts";

interface IRideStationPanelGreyed {
  rideDto: IRideDto;
  mode: RideStationPanelMode;
}

export const RideStationsPanelGreyed: FC<IRideStationPanelGreyed> = ({
  rideDto,
  mode,
}) => {
  const stationsCollapsedIds = useRecoilValue(
    rideStationsCollapsedIdsAF(rideDto.id || 0),
  );

  const sortableComposedIds = useMemo(() => {
    const sortableIdsComputed =
      rideDto.metadata?.stationsInfo?.map(getStationComposedId) || [];

    return sortableIdsComputed;
  }, [rideDto.metadata?.stationsInfo]);

  const allStationsCollapsed = useMemo(() => {
    const stationsIds =
      (isArray(rideDto?.metadata?.stationIds) &&
        rideDto?.metadata?.stationIds) ||
      [];
    return isEqualNumberArraysAnyOrder(
      [...stationsIds],
      [...stationsCollapsedIds],
    );
  }, [rideDto?.metadata?.stationIds, stationsCollapsedIds]);

  return (
    <>
      {Boolean(rideDto) && (
        <RideStationsPanelStyled>
          <RideStationsHeader
            rideDto={rideDto}
            allStationsCollapsed={allStationsCollapsed}
          />
          {Boolean(sortableComposedIds.length) &&
            sortableComposedIds.map((stationComposedId, index) => {
              return (
                <RideStationWrapper
                  key={stationComposedId}
                  stationComposedId={stationComposedId}
                  rideDto={rideDto}
                  isFirstStation={index === 0}
                  isLastStation={index === sortableComposedIds.length - 1}
                  mode={mode}
                  index={index}
                  isGreyed={true}
                />
              );
            })}
        </RideStationsPanelStyled>
      )}
    </>
  );
};
